import styled from 'styled-components/macro';

import TableBase from '@components/common/core/Utils/Table';

export const ProductCostTable = styled(TableBase)``;
